import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Card,
  FormControlLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
  Modal,
  CircularProgress,
  OutlinedInput,
  FormControl,
  InputLabel,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import CommonTable from "../../common/CommonTable";
import { API_URL } from "../../utils/constants";
import axios from "axios";
import { cssProperties } from "../../utils/commonCssProperties";
import MauvelousPrimaryButton from "../../common/button/mauvelousPrimaryButton";
import ViewButton from "../../common/button/viewButton";
import BluePrimaryButton from "../../common/button/bluePrimaryButton";
import masterActions from "../../redux/master/actions";
import { useDispatch, useSelector } from "react-redux";
import commonActions from "../../redux/common/actions";
import JSZip from "jszip";
import { IoClose } from "react-icons/io5";
import xlsx from "json-as-xlsx";
import GreenButton from "../../common/button/greenButton";
import modifyWordFileCard  from "../../common/wordFilemodify";
import Barcode from 'react-barcode';

const Index = () => {
  const [uploadfile, setUploadedFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [modifiedFileUrl, setModifiedFileUrl] = useState(null);
  const [ipAddress, setIpAddress] = useState(null);
  const now = new Date();
  const [searchRollNo, setSearchRollNo] = useState("");
  const [message, setMessage] = useState("");
  const [metadata, setMetaData] = useState("");
  const [showiframe, setShowIframe] = useState("");
  const[filteredResults,setFilteredResults]=useState(null);
  const { coursecandidatelist } = useSelector(state => state.masterReducer);
  const { getAdmitCardDownloadList } = useSelector(state => state.masterReducer);
  const[id,setId] = useState(0)
  const dispatch = useDispatch();
  const barcodeRef = useRef(null);
  const [barcodeDataUrl, setBarcodeDataUrl] = useState('');
const [candidate,setCandidateid]=useState(null);
useEffect(() => {
  if (barcodeRef.current) {
    const svgElement = barcodeRef.current.querySelector('svg');

    if (svgElement) {
      const svgString = new XMLSerializer().serializeToString(svgElement);
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();

      const svgBlob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
      const url = URL.createObjectURL(svgBlob);

      img.onload = () => {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        const dataUrl = canvas.toDataURL('image/png');
        setBarcodeDataUrl(dataUrl);
        URL.revokeObjectURL(url);
      };

      img.src = url;
    }
  }
}, [candidate]);
  const handleChange = (event) => {
    setId(event.target.value);
  };
  const formatTime = (timeString) => {
    if (!timeString) return "";
    
    let [hh, mm] = timeString.split(":").map(Number);
    const period = hh >= 12 ? "PM" : "AM";
  
    hh = hh % 12 || 12;
  
    return `${hh}:${mm.toString().padStart(2, "0")} ${period}`;
  };
  const isoDate = now.toISOString().split("T")[0]; 
  const isoTime = now.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: false });  
  const formatDate1 = (dateString) => {
    if (!dateString) return "";
    const [yyyy, mm, dd] = dateString.split("-"); 
    return `${dd}/${mm}/${yyyy}`; 
  };
  
  useEffect(() => {
    const fetchIpAddress = async () => {
      try {
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();
        setIpAddress(data.ip);
      } catch (error) {
      }
    };

    fetchIpAddress();
  }, []);

  const placeholders = [
    { originalText: "<name>", replaceText: /<name>/g, value: filteredResults?.[0]?.candidatename,Name:"Candidate’s Full Name" },
    { originalText: "<rollno>", replaceText: /<rollno>/g, value: filteredResults?.[0]?.rollno,Name:"Roll Number" },
    { originalText: "<gender>", replaceText: /<gender>/g, value: filteredResults?.[0]?.gender,Name:"Gender" },
    { originalText: "<appno>", replaceText: /<appno>/g, value: filteredResults?.[0]?.applicantid,Name:"Application Number" },
    { originalText: "<examtime>", replaceText: /<examtime>/g, value: formatTime(filteredResults?.[0]?.starttime),Name:"Exam Start Time" },
    { originalText: "<reptime>", replaceText: /<reptime>/g, value: formatTime(filteredResults?.[0]?.reportingtime),Name:"Reporting Time at the CET examination Centre" },
    { originalText: "<closuretime>", replaceText: /<closuretime>/g, value: formatTime(filteredResults?.[0]?.endtime),Name:"Gate Closure Time" },
    { originalText: "<lang>", replaceText: /<lang>/g, value: filteredResults?.[0]?.languagename,Name:"Question Paper Language" },
    { originalText: "<examdate>", replaceText: /<examdate>/g, value: formatDate1(filteredResults?.[0]?.examdate),Name:"Date of Examination" },
    { originalText: "<dob>", replaceText: /<dob>/g, value:formatDate1 (filteredResults?.[0]?.dob),Name:"Date of Birth" },
    { originalText: "<disability>", replaceText: /<disability>/g, value: filteredResults?.[0]?.isdisability == 1 ? "Yes" : "No" ,Name:"Person with Disability (PWD)"},
    { originalText: "<disabilitytype>", replaceText: /<disabilitytype>/g, value: filteredResults?.[0]?.disabilitytype,Name:"Disability Type" },
    { originalText: "<isextratime>", replaceText: /<isextratime>/g, value: filteredResults?.[0]?.isextratime== 1 ? "Yes" : "No",Name:"Extra Time Required" },
    { originalText: "<ipaddress>", replaceText: /<ipaddress>/g, value: ipAddress,Name:"Ip Address" },
    { originalText: "<date>", replaceText: /<date>/g, value: formatDate1(isoDate),Name:"Date of download of Admit Card" },
    { originalText: "<time>", replaceText: /<time>/g, value: formatTime(isoTime),Name:"Time of download of Admit Card" },
    { originalText: "<coursename>", replaceText: /<coursename>/g, value: filteredResults?.[0]?.coursename,Name:"Course name" },
    { originalText: "<scribe>", replaceText: /<scribe>/g, value: filteredResults?.[0]?.isscribe == 1 ? "Yes" : "No" ,Name:"Isscribe"},
    { originalText: "<venuecode>", replaceText: /<venuecode>/g, value: filteredResults?.[0]?.referenceid,Name:"Venue Code" },
    { originalText: "<venueaddress>", replaceText: /<venueaddress>/g, value: filteredResults?.[0]?.address1,Name:"Venue Address" },
    { originalText: "<physics>", replaceText: /<physics>/g, value:'61', Name: "Physics" },
    { originalText: "<chemistry>", replaceText: /<chemistry>/g, value:'66', Name: "Chemistry" },
    { originalText: "<biology>", replaceText: /<biology>/g, value:'66', Name: "Biology" },
    { originalText: "<nursing>", replaceText: /<nursing>/g, value:'66', Name: "Nursing" },
    { originalText: "<totalscore>", replaceText: /<totalscore>/g, value:'66', Name: "Totalscore" },
    { originalText: "<english>", replaceText: /<english>/g, value:'66', Name: "English" },
    { originalText: "<percentile>", replaceText: /<percentile>/g, value:filteredResults?.[0]?.percentage, Name: "Percentage" },
    { originalText: "<dateofresult>", replaceText: /<dateofresult>/g, value:formatDate1(filteredResults?.[0]?.scorecardstartdate), Name: "Date of result" }// { originalText: "<image>",Name:"Photo" },
    // { originalText: "<signature>",Name:"Signature" },
  ];


















  // const handleViewAdmitcard = async (candidateid) => {
  //   setCandidateid(candidateid);
    
  //   await dispatch({
  //     type: masterActions.GET_COURSE_CANDIDATE_LIST,
  //     payload: {
  //       courseid: id,
  //       candidateid: candidateid, 
  //     },
  //   });
  
  //   setIsDialogOpen(true);
  //   await setFilteredResults(coursecandidatelist?.filter(
  //     (item) => item.candidateid === candidateid
  //   ))
  // //  const candidate = getAdmitCardDownloadList?.find(
  // //         (item) => item?.candidateid === candidateid
  // //       );
  // const candidate = Array.isArray(getAdmitCardDownloadList)
  // ? getAdmitCardDownloadList.find((item) => item?.candidateid === candidateid)
  // : null;

  //   await modifyWordFileCard({
  //     uploadfile,
  //     dispatch,
  //     filteredResults,
  //     setModifiedFileUrl,
  //     setPreview,
  //     placeholders,
  //     setMessage,
  //     setIsDialogOpen,
  //     setMetaData,
  //     setShowIframe,
  //     barcodeDataUrl
  //     // candidateName:candidateid?.candidateName 
  //   });
    
  // };
  
  const handleViewAdmitcard = async (candidateid) => {
    setCandidateid(candidateid);
  
    await dispatch({
      type: masterActions.GET_COURSE_CANDIDATE_LIST,
      payload: {
        courseid: id,
        candidateid: candidateid,
      },
    });
  
    const filteredCandidate = coursecandidatelist?.filter(
      (item) => item.candidateid === candidateid
    );
  
    setFilteredResults(filteredCandidate);
  
    await modifyWordFileCard({
      uploadfile,
      dispatch,
      filteredResults,
      setModifiedFileUrl,
      setPreview,
      placeholders,
      setMessage,
      setIsDialogOpen,
      setMetaData,
      setShowIframe,
      barcodeDataUrl,
    });
  
    setIsDialogOpen(true);
  };
  
  let settings = {
    fileName: "AdmitCard Report",
    extraLength: 3,
    writeMode: "writeFile",
    writeOptions: {},
    RTL: false,
  };
  let callback = function (sheet) {
  };


  const handleDownloadCandidates = async () => {
    if (getAdmitCardDownloadList?.result && getAdmitCardDownloadList?.result.length > 0) {
      let columns = [];

      for (let i = 0; i < Object.keys(getAdmitCardDownloadList?.result[0]).length; i++) {
        let obj = {};
        obj.label = Object.keys(getAdmitCardDownloadList?.result[0])[i];
        obj.value = Object.keys(getAdmitCardDownloadList?.result[0])[i];
        columns.push(obj);
      }

      let data = [
        {
          sheet: "AdmitCard Total Candidate",
          columns: columns,
          content: getAdmitCardDownloadList?.result,
        },
      ];
      xlsx(data, settings, callback);
    } else {
    }
  };
  const handleDownloadDownloadedCandidates = async () => {
    if (getAdmitCardDownloadList?.result && getAdmitCardDownloadList?.result.length > 0) {
      const filteredResults = getAdmitCardDownloadList.result.filter(obj => obj.downloadtimestamp);
  
      if (filteredResults.length > 0) {
        let columns = [];
  
        for (let i = 0; i < Object.keys(filteredResults[0]).length; i++) {
          let obj = {};
          obj.label = Object.keys(filteredResults[0])[i];
          obj.value = Object.keys(filteredResults[0])[i];
          columns.push(obj);
        }
  
        let data = [
          {
            sheet: "AdmitCard Downloaded Details",
            columns: columns,
            content: filteredResults, 
          },
        ];
  
        xlsx(data, settings, callback);
      } else {
      }
    } else {
    }
  };
  
  const handleDownloadYetToDownload = async () => {
    if (getAdmitCardDownloadList?.result && getAdmitCardDownloadList?.result.length > 0) {
      const filteredResults = getAdmitCardDownloadList.result.filter(obj => !obj.downloadtimestamp);
  
      if (filteredResults.length > 0) {
        let columns = [];
  
        for (let i = 0; i < Object.keys(filteredResults[0]).length; i++) {
          let obj = {};
          obj.label = Object.keys(filteredResults[0])[i];
          obj.value = Object.keys(filteredResults[0])[i];
          columns.push(obj);
        }
  
        let data = [
          {
            sheet: "AdmitCard YetToDownload Details",
            columns: columns,
            content: filteredResults,
          },
        ];
  
        xlsx(data, settings, callback);
      } else {
      }
    } else {
    }
  };
  





  useEffect(() => {
    if (id !== 0) {
      dispatch({
        type: masterActions.GET_COURSE_CANDIDATE_LIST,
        payload: { courseid: id,
          candidateid:0
         },
      });
    }
  }, [dispatch, id]);
  const candidateInfoColumns = [
    {
      name: "Sr. No",
      dataIndex: "srNo",
    },
    {
      name: "Candidate's Name",
      dataIndex: "candidateName",
    },
    {
      name: "Roll No",
      dataIndex: "rollno",
    },
    {
      name: "Admitcard",
      dataIndex: "view",
      render: (value, row) => (
        <MauvelousPrimaryButton 
        handleClick={() => {
          handleViewAdmitcard(row.candidateid);
        }}
        title={"Preview"}
      />
        
    
      
      ),
    },
  ];






  useEffect(()=>{
    setUploadedFile(coursecandidatelist?.[0]?.templatedocs);
  },[coursecandidatelist])
  
  const uniqueApplicants = new Map();

  const filteredTableData = coursecandidatelist
  ?.filter(item => {
    if (!uniqueApplicants.has(item.applicantid)) {
      uniqueApplicants.set(item.applicantid, true);
      return true;
    }
    return false;
  })
  .map((item, index) => ({
    srNo: index + 1,
    applicationNo: item.applicantid, 
    candidateName: item.candidatename,
    view: "view",
    candidateid: item.candidateid,
    templatedocs: item.templatedocs,
    rollno: item.rollno,
  }));

const formattedTableData = searchRollNo
  ? filteredTableData?.filter(row =>
      row?.rollno?.toString().toLowerCase().includes(searchRollNo.toLowerCase())
    ):[]
  



  useEffect(() => {
    if (id) {
      dispatch({
        type: masterActions.GET_ADMITCARD_DOWNLOAD_LIST,
        payload: { courseid: id },
      });
    }
  }, [id]);

  const resultList = getAdmitCardDownloadList?.result || [];
const totalCandidates = resultList.length;
const downloadedCandidates = resultList.filter(obj => obj.downloadtimestamp).length;
const yetToDownload = totalCandidates - downloadedCandidates;

  const { courseList } = useSelector((state) => state.masterReducer);
  useEffect(() => {
    dispatch({ type: masterActions.GET_COURSE_LIST });
  }, [dispatch]);

  return (
 <>
   <form>
   <Grid container paddingBottom={2}>
  <Grid 
    item 
    md={7} 
    sx={{ 
      display: "flex", 
      alignItems: "center", 
      gap: 2, 
      flexWrap: "nowrap" // Prevents items from wrapping
    }}
  >
    {/* Select Dropdown */}
    <FormControl sx={{ minWidth: 200, maxWidth: 250 }}>
      <Select
        size="small"
        value={id}
        onChange={handleChange}
        sx={{ 
          width: "100%", 
          whiteSpace: "nowrap", 
          overflow: "hidden", 
          textOverflow: "ellipsis" 
        }}
      >
        <MenuItem value={0}>Courses</MenuItem>
        {courseList?.all?.map((course, i) => (
          <MenuItem key={i} value={course.courseid} sx={{ whiteSpace: "nowrap" }}>
            {course.coursename}
          </MenuItem>
        ))}
      </Select>
    </FormControl>

    <FormControl sx={{ flexGrow: 1, minWidth: 250 }} variant="outlined">
      <InputLabel htmlFor="search-rollno">Search by Rollno</InputLabel>
      <OutlinedInput id="search-rollno" label="Search by Rollno"   value={searchRollNo}
            onChange={(e) => setSearchRollNo(e.target.value)}/>
    </FormControl>

    {/* <MauvelousPrimaryButton title="Search" /> */}
  </Grid>
<Grid container mb={1} mt={1} sx={{ display: "flex", gap: 2 }}>
  {[
    { 
      count:totalCandidates, 
      label: "Candidates",
      // onClick: () => handleCandidatesClick(), 
      buttonAction: () => handleDownloadCandidates(),
    },
    { 
      count: downloadedCandidates, 
      label: "Downloaded candidates",
      // onClick: () => handleDownloadedClick(), 
      buttonAction: () => handleDownloadDownloadedCandidates(),
    },
    { 
      count: yetToDownload >= 0 ? yetToDownload : 0, 
      label: "Yet to download",
      // onClick: () => handleYetToDownloadClick(), 
      buttonAction: () => handleDownloadYetToDownload(), 
    },
  ].map((item, index) => (
    <Card
      key={index}
      sx={{
        flex: 1,
        textAlign: "center",
        borderRadius: 2,
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "none",
        p: 2,
        border: `1px solid ${cssProperties.bordercolor.secondary}`,
      }}
      onClick={item.onClick} 
    >
      <Typography variant="body1" color={cssProperties.color.failure} fontWeight={600} pb={2}>
        {item.count}
      </Typography>
      <Typography variant="body1" color="#212121" fontWeight={600}>
        {item.label}
      </Typography>
      <GreenButton
        handleSubmit={item.buttonAction} 
        title="Download"
      />
    </Card>
  ))}
</Grid>

</Grid>

<div ref={barcodeRef} style={{display:"none"}}>
  <Barcode 
    value={filteredResults?.[0]?.rollno} 
    height={150}   
    width={3}     
    displayValue={true} 
  />
</div>
      </form>
      { (formattedTableData && formattedTableData?.length>0) && <CommonTable
            columnData={candidateInfoColumns}
            tableData={formattedTableData}
          />}

   {isDialogOpen && (
        <Dialog open={isDialogOpen} maxWidth="xl" fullWidth>

          <DialogTitle>
  <Box
    mt={2}
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    }}
  >
    <Typography sx={{ flexGrow: 1, textAlign: "center" }}>
      Preview AdmitCard
    </Typography>

    <Box sx={{ display: "flex", gap: 1, ml: "auto" }}>


      <button
        onClick={() => {
          setIsDialogOpen(false);
          dispatch({
            type: masterActions.GET_COURSE_CANDIDATE_LIST,
            payload: {
              courseid: id,
              candidateid: 0,
            },
          });
          setPreview("")
        }}
        
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "40px",
          height: "40px",
          cursor:"pointer",
        }}
      >
        <IoClose size={16} />
      </button>
    </Box>
  </Box>
</DialogTitle>

          <DialogContent>
            <Box sx={{ height: "500px", overflow: "hidden" }}>

                      <iframe 
  src={preview} 
  width="100%" 
  height="600px"
  style={{ border: "none",marginTop:"10px" }}
></iframe>
            </Box>
          </DialogContent>
        </Dialog>
      )}
         {(formattedTableData?.length == 0 ||
            formattedTableData == undefined) &&
 (
              <Box>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: "bold", textAlign: "center" ,marginTop:"10px"}}
                >
                  No Records Found
                </Typography>
              </Box>
            )}
 </>
  );
};

export default Index;
